export default "__VITE_ASSET__D8jbw_p1__"